/* eslint-disable func-names */

/**
 * Class for game model.
 */
export default function GameModel()
{

}

/**
 * Gets the font with variations.
 *
 * @return {String}  The font with variations.
 */
GameModel.prototype.getFontWithVariations = function ()
{
    return this.font + this.fontVariations;
};

/**
 * Gets the stake.
 *
 * @return {Number}  The stake.
 */
GameModel.prototype.getStake = function ()
{
    if (this.stake !== undefined)
    {
        return this.stake;
    }
    return this.defaultStake;
};

/**
 * Gets the currency multiplier.
 *
 * @return {Number}  The currency multiplier.
 */
GameModel.prototype.getCurrencyMultiplier = function ()
{
    return this.defaultStake / this.baseMultiplier;
};

/**
 * Determines if out of tickets.
 *
 * @return {boolean}  True if out of tickets, False otherwise.
 */
GameModel.prototype.isOutOfTickets = function ()
{
    const bm = this.isBasketMode();
    const hr = this.hasRoundsLeft();

    let res = false;

    if (bm && !hr) { res = true; }

    return res;
};

/**
 * Determines if out of funds.
 *
 * @return {Boolean}  True if out of funds, False otherwise.
 */
GameModel.prototype.isOutOfFunds = function ()
{
    const bm = this.isBasketMode();
    const ba = this.getBalance();

    if (!bm && (ba <= 0)) { return true; }

    return false;
};

/**
 * Gets the help url.
 *
 * @return {String}  The help url.
 */
GameModel.prototype.getHelpUrl = function ()
{
    if (!this.showHelpButton) { return null; }

    const mu = this.getCurrencyMultiplier();
    const cc = this.currencyCode;
    const rc = false; // 888 Hack to hide RC info in help file

    let url = `${this.helpUrl}&data=cc-${cc}$mu-${mu}$rc-${rc}&v=${window.__version}`;

    if (this.apiGameCode)
    {
        url = url.replace(this.gameCode, 'PP_HTML5_FelineQueen60');
    }

    return url;
};

/**
 * Determines if maximum prize.
 *
 * @param  {Number}   index  The index
 * @return {Boolean}  True if maximum prize, False otherwise.
 */
GameModel.prototype.isMaxPrize = function (index)
{
    return this.maxPrize === Number(index);
};

/**
 * Gets the status.
 *
 * @return {StatusModel}  The status.
 */
GameModel.prototype.getStatus = function ()
{
    return this.status;
};

/**
 * Gets the balance.
 *
 * @return {Number}  The balance.
 */
GameModel.prototype.getBalance = function ()
{
    const s = this.getStatus();

    if (!s)
    {
        return null;
    }

    return s.balance;
};

/**
 * Sets the balance.
 *
 * @param  {Number}  v  { parameter_description }
 */
GameModel.prototype.setBalance = function (v)
{
    const s = this.getStatus();

    if (!s)
    {
        return;
    }

    s.balance = v;
};

/**
 * Gets the financial mode.
 *
 * @return {Number}  The financial mode.
 */
GameModel.prototype.getFinancialMode = function ()
{
    const s = this.getStatus();

    if (!s)
    {
        return null;
    }

    return s.financialMode;
};

/**
 * Determines if basket mode.
 *
 * @return {boolean}  True if basket mode, False otherwise.
 */
GameModel.prototype.isBasketMode = function ()
{
    return this.getFinancialMode() === 1;
};

/**
 * Gets the rounds left.
 *
 * @return {Number}  The rounds left.
 */
GameModel.prototype.getRoundsLeft = function ()
{
    const s = this.getStatus();

    if (!s)
    {
        return null;
    }

    return s.roundsLeft;
};

/**
 * Sets the rounds left.
 *
 * @param  {Number}  v  { parameter_description }
 */
GameModel.prototype.setRoundsLeft = function (v)
{
    const s = this.getStatus();

    if (!s)
    {
        return;
    }

    s.roundsLeft = v;
};

/**
 * Determines if it has rounds left.
 *
 * @return {Boolean}  True if has rounds left, False otherwise.
 */
GameModel.prototype.hasRoundsLeft = function ()
{
    return this.getRoundsLeft() > 0;
};

/**
 * Gets the sound.
 *
 * @return {Number}  The sound.
 */
GameModel.prototype.setSoundAndMute = function ()
{
    const s = this.sound;

    if (typeof (s) === 'number')
    {
        if (s > 0)
        {
            this.defaultVolume = s;
            this.setMute(false);
        }
        else
        {
            this.setMute(true);
        }
    }

    else if (typeof (s) === 'boolean')
    {
        this.setMute(!s);
    }

    else
    {
        const muteString = window.localStorage.getItem('mute');

        this.setMute(muteString !== 'false');
    }

    return this.defaultVolume;
};

/**
 * Gets the sound.
 *
 * @return {Number}  The sound.
 */
GameModel.prototype.getSound = function ()
{
    return this.defaultVolume;
};

/**
 * Gets the mute.
 *
 * @return {Boolean}  The mute.
 */
GameModel.prototype.getMute = function ()
{
    console.log('getMute',this.mute)
    return this.mute;
};

/**
 * Sets the mute.
 *
 * @param  {Boolean}  v  { parameter_description }
 */
GameModel.prototype.setMute = function (v)
{
    console.log('setMute',v)
    this.mute = v;
    window.localStorage.setItem('mute', v);
};

GameModel.prototype.isAutoplaying = function(before,after,stake)
{
    return this.autoplayRounds > 0;
}

GameModel.prototype.decreaseAutoplay = function()
{
    return this.autoplayedRounds -= 1;
}

GameModel.prototype.resetAutoplay = function()
{
    this.hasUserStartedAutoplay = false
    this.autoplayWin = 0
    this.autoplayLoss = 0
    return this.autoplayedRounds = this.autoplayRounds;
}

GameModel.prototype.stopAutoplay = function()
{
    this.hasUserStartedAutoplay = false
    this.autoplayWin = 0
    this.autoplayLoss = 0
    this.autoplayedRounds = 0;
    this.autoplayRounds = 0;
}

GameModel.prototype.updateAutoplayState = function(win,loss)
{
    if(!this.isAutoplaying())
    {
        return 0;
    }

    this.autoplayWin += win
    this.autoplayLoss += loss

    let reason = null;

    if (win >= this.singleWin && this.singleWin > 0)
    {
        reason = __t.str('Single win limit reached!')
    }
    else if ((this.autoplayLoss-this.autoplayWin) >= this.lossLimit && this.lossLimit > 0)
    {
        reason = __t.str('Loss limit reached!')
    }

    if (reason !== null)
    {
        this.autoplayedRounds = 0;
    }

    return reason;
};


// WEBPACK FOOTER //
// ./babel/model/game-model.js